export default {
  InInwardList: {
    Inward: 'Nhập kho',
  },
  InInwardDetail: {
    Text: {
      Object: 'Đối tượng',
      DelivererAccountingObject: 'Người giao',
      AccountingObject: 'Người nhận tiền',
      RefNo: 'Số PN',
      RefNoOther: 'Số CT',
      RefDate: 'Ngày PN',
      RefDateOther: 'Ngày CT',
      PostedDate: 'Ngày HT',
      Description: 'Diễn giải',
      FullName: 'Họ tên',
      Address: 'Địa chỉ',
      Currency: 'Loại tiền',
      DepartmentName: 'Tên phòng ban',
      BankInfo: 'TKKB',
      DocumentIncluded: 'Kèm theo',
      VoucherReferance: 'CT tham chiếu',
      SecondRefNo: 'Số PC',
      ImportRefNo: 'Số GR',
      ThirdRefNo: 'Số GBN',
      DefaultMethodDistributeName: 'Dự toán',
      DefaultCashWithDrawTypeName: 'Tạm ứng - dự toán',
    },
    Title: {
      BankInfo: 'Tài khoản kho bạc',
      VoucherReferance: 'Chứng từ tham chiếu',
      RefNo: 'Số phiếu nhập',
      RefNoOther: 'Số chứng từ',
      RefDate: 'Ngày phiếu nhập',
      RefDateOther: 'Ngày chứng từ',
      PostedDate: 'Ngày hạch toán',
      SecondRefNo: 'Số phiếu chi',
      ImportRefNo: 'Số giấy rút',
      ThirdRefNo: 'Số giấy báo nợ',
    },

    Warning: {
      MissCCDCInfo: 'Chưa nhập vật tư tại dòng {0}.',
      MissStock: 'Chưa nhập kho.',
    },
  },
};
